<template>
    <div>
        <RangePickerWithPeriod v-if="showTimeRangeComp"
            v-model:selected="currentValue"
            class="custom-comp"
            :format="format"
            :ranges="rangeTimes"
            :disabled="disabled"
            @change="changeValue"
        />
        
        <a-date-picker v-else
            :showToday="false"
            class="custom-comp"
            :disabled="disabled"
            v-model:value="currentValue" 
            @change="changeValue" 
            :format="format"/>
    </div>
</template>

<script lang="ts" name="filterTime" setup>
import { ref, watch } from 'vue';
import moment from 'moment';
import RangePickerWithPeriod from '/@/components/Board/RangePickerWithPeriod.vue';
import { SubmitParams } from '../config';

const props = defineProps({
    rule: String,
    column: Object,
    value: [Array, String],
    disabled: Boolean,
});
const showTimeRangeComp = ref(false);

const showTimeRules = ['eq']

const emit = defineEmits(['update:value', 'change'])
const currentValue = ref(null)
let hasInited = false;

watch(() => props.value, (value: Array<String>) => {
    if (!hasInited) {
        hasInited = true;
        if (value?.length) {
            currentValue.value = value;
            return;
        }
        const defaultValue = props.column?.otherCustom?.defaultValue;

        if (defaultValueConfig[defaultValue]) {
            currentValue.value = defaultValueConfig[defaultValue];
            changeValue();
            return;
        }
    }
    currentValue.value = value;
}, {
    immediate: true,
})

watch(() => props.rule, (value) => {
    showProperTimeComp();
}, {
    immediate: true,
})

function changeValue() {
    emit('update:value', transformTime(currentValue.value, props.rule));
    emit('change', transformTime(currentValue.value, props.rule))
}

function showProperTimeComp() {
    showTimeRangeComp.value = showTimeRules.includes(props.rule)
}
</script>

<script lang="ts">
const format='YYYY-MM-DD';
const rangeTimes = { 
    '今日': [moment().startOf('day'), moment()],
    '昨日': [moment(new Date()).subtract(1, 'days').startOf('day'), moment(new Date()).subtract(1, 'days').endOf('day')],
    '本周': [moment().startOf('week'), moment()],
    '上月': [moment(new Date()).subtract(1, 'months').startOf('month'), moment(new Date()).subtract(1, 'months').endOf('month')],
    '本月': [moment().startOf('month'), moment()],
    '本季度': [moment().startOf('quarter'), moment()],
    '本年': [moment().startOf('year'), moment()],
};

const defaultValueConfig = {
    ...rangeTimes,
    lastYear: [moment(new Date()).subtract(1, 'years').add(1, 'days').startOf('day'), moment()],
}

function transformTime(time, rule) {
    if ((Array.isArray(time) && !time.length) || (!Array.isArray(time) && !time)) {
        return null;
    }
    let result = null;
    const endTime = ' 23:59:59';
    const startTime = ' 00:00:00';
    const greatThanRules = ['gt', 'ge']
    if (Array.isArray(time) && time.length) {
        result = [
            time?.[0] && moment(time[0]).format(format) + startTime,
            time?.[1] && moment(time[1]).format(format) + endTime,
        ]
    } else {
        if (greatThanRules.includes(rule)) {
            result = moment(time).format(format) + endTime;
        } else {
            result = moment(time).format(format) + startTime;
        }
    }

    return result;
}

export const getDefaultFilterTimeValue: (column) => SubmitParams = (column) => {
    const defaultValue = column?.otherCustom?.defaultValue;
    const defaultRule = column?.otherCustom?.defaultRule;
    if (defaultValueConfig[defaultValue] && defaultRule) {
        return {
            javaType: column.javaType,
            htmlType: column.htmlType,
            field: column.javaField,
            rule: defaultRule,
            val: transformTime(defaultValueConfig[defaultValue], defaultRule),
        };
    }
}

</script>

<style lang="less" scoped>
:deep(.ant-calendar-picker-input) {
    width: 100%;
}

.custom-comp {
    width: 100%;
}
</style>